import React from 'react';

import './GenericErrorCard.css';

interface GenericErrorCardProps {
  title: string;
  text: React.ReactNode;
  imgSrc: string;
  button?: React.ReactNode;
}

function GenericErrorCard({ title, text, imgSrc, button }: GenericErrorCardProps) {
  return (
    <div className="generic-error-card">
      <div className="generic-error-card-content">
        <div>
          <h2>{title}</h2>
          <p>{text}</p>
          {button ? button : null}
        </div>
        <div>
          <img src={imgSrc} alt="generic error card icon" />
        </div>
      </div>
    </div>
  );
}

export default GenericErrorCard;
